const WORKER_TEMPLATES = [
    {
      template_id: 890190, //mainnet: 890190 // testnet: 660028
      worker_name: 'Bronze Worker',
      type: 'Ranch',
      img: require('../assets/worker/bronze_ranch_worker.webp'),
      img_worker: require('../assets/icons/bronze_ranch_worker.webp'),
      saved_claims: 1,
      additional_slots: 1,
      additional_stamina: 200,
      rewards_rate: [1, 2, 3],
      lucky: 10,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 2,
      stamina: 100
    },
    {
      template_id: 890194, //mainnet: 890194 // testnet: 660032
      worker_name: 'Silver Worker',
      type: 'Ranch',
      img: require('../assets/worker/silver_ranch_worker.webp'),
      img_worker: require('../assets/icons/silver_ranch_worker.webp'),
      saved_claims: 2,
      additional_slots: 2,
      additional_stamina: 400,
      rewards_rate: [2, 3, 4, 5, 6],
      lucky: 20,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 4,
      stamina: 200
    },
    {
      template_id: 890197, //mainnet: 890197 // testnet: 660035
      worker_name: 'Gold Worker',
      type: 'Ranch',
      img: require('../assets/worker/gold_ranch_worker.webp'),
      img_worker: require('../assets/icons/gold_ranch_worker.webp'),
      saved_claims: 3,
      additional_slots: 2,
      additional_stamina: 800,
      rewards_rate: [3, 4, 5, 6, 7, 8, 9],
      lucky: 30,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 6,
      stamina: 300
    },
    {
      template_id: 890200, //mainnet: 890200 // testnet: 660038
      worker_name: 'Diamond Worker',
      type: 'Ranch',
      img: require('../assets/worker/diamond_ranch_worker.webp'),
      img_worker: require('../assets/icons/diamond_ranch_worker.webp'),
      saved_claims: 4,
      additional_slots: 3,
      additional_stamina: 1200,
      rewards_rate: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      lucky: 40,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 9,
      stamina: 400
    },
    {
      template_id: 890192, //mainnet: 890192 // testnet: 660030
      worker_name: 'Bronze Worker',
      type: 'Farm',
      img: require('../assets/worker/bronze_farm_worker.webp'),
      img_worker: require('../assets/icons/bronze_farm_worker.webp'),
      saved_claims: 1,
      additional_slots: 1,
      additional_stamina: 200,
      rewards_rate: [1, 2, 3],
      lucky: 10,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 2,
      stamina: 100
    },
    {
      template_id: 890195, //mainnet: 890195 // testnet: 660033
      worker_name: 'Silver Worker',
      type: 'Farm',
      img: require('../assets/worker/silver_farm_worker.webp'),
      img_worker: require('../assets/icons/silver_farm_worker.webp'),
      saved_claims: 2,
      additional_slots: 2,
      additional_stamina: 400,
      rewards_rate: [2, 3, 4, 5, 6],
      lucky: 20,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 4,
      stamina: 200
    },
    {
      template_id: 890198, //mainnet: 890198 // testnet: 660036
      worker_name: 'Gold Worker',
      type: 'Farm',
      img: require('../assets/worker/gold_farm_worker.webp'),
      img_worker: require('../assets/icons/gold_farm_worker.webp'),
      saved_claims: 3,
      additional_slots: 2,
      additional_stamina: 800,
      rewards_rate: [3, 4, 5, 6, 7, 8, 9],
      lucky: 30,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 6,
      stamina: 300
    },
    {
      template_id: 890201, //mainnet: 890201 // testnet: 660039
      worker_name: 'Diamond Worker',
      type: 'Farm',
      img: require('../assets/worker/diamond_farm_worker.webp'),
      img_worker: require('../assets/icons/diamond_farm_worker.webp'),
      saved_claims: 4,
      additional_slots: 3,
      additional_stamina: 1200,
      rewards_rate: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      lucky: 40,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 9,
      stamina: 400
    },
    {
      template_id: 890193, //mainnet: 890193 // testnet: 660031
      worker_name: 'Bronze Worker',
      type: 'Tool',
      img: require('../assets/worker/bronze_tool_worker.webp'),
      img_worker: require('../assets/icons/bronze_tool_worker.webp'),
      saved_claims: 1,
      additional_slots: 1,
      additional_stamina: 200,
      rewards_rate: [1, 2, 3],
      lucky: 10,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 2,
      stamina: 100
    },
    {
      template_id: 890196, //mainnet: 890196 // testnet: 660034	
      worker_name: 'Silver Worker',
      type: 'Tool',
      img: require('../assets/worker/silver_tool_worker.webp'),
      img_worker: require('../assets/icons/silver_tool_worker.webp'),
      saved_claims: 2,
      additional_slots: 2,
      additional_stamina: 400,
      rewards_rate: [2, 3, 4, 5, 6],
      lucky: 20,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 4,
      stamina: 200
    },
    {
      template_id: 890199, //mainnet: 890199 // testnet: 660037
      worker_name: 'Gold Worker',
      type: 'Tool',
      img: require('../assets/worker/gold_tool_worker.webp'),
      img_worker: require('../assets/icons/gold_tool_worker.webp'),
      saved_claims: 3,
      additional_slots: 2,
      additional_stamina: 800,
      rewards_rate: [3, 4, 5, 6, 7, 8, 9],
      lucky: 30,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 6,
      stamina: 300
    },
    {
      template_id: 890202, //mainnet: 890202 // testnet: 660040
      worker_name: 'Diamond Worker',
      type: 'Tool',
      img: require('../assets/worker/diamond_tool_worker.webp'),
      img_worker: require('../assets/icons/diamond_tool_worker.webp'),
      saved_claims: 4,
      additional_slots: 3,
      additional_stamina: 1200,
      rewards_rate: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      lucky: 40,
      unstaking_time: 259200,
      charged_time: 86400,
      reward: 9,
      stamina: 400
    },
  ];

  export default WORKER_TEMPLATES;